export const formDefaultValues = {
  price: '',
  priceFirstTime: '',
}
